// Seguro anti-salto para páginas de producto: si en los primeros segundos
// la página se desplaza sola (sin que el usuario haya tocado, deslizado ni
// usado el teclado), la regresa arriba. Cubre saltos que dependen del
// navegador/celular (restauración de scroll, anclaje por contenido que
// carga tarde, foco automático) y que no siempre se reproducen igual en
// todos los equipos.
(function () {
  if (location.hash) return;
  try {
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  } catch (e) {}

  var usuarioActuo = false;
  var VENTANA_MS = 4000;
  var inicio = Date.now();
  var eventos = ['touchstart', 'pointerdown', 'wheel', 'keydown', 'mousedown'];

  function marcarUsuario() {
    usuarioActuo = true;
    quitar();
  }
  function quitar() {
    eventos.forEach(function (e) { window.removeEventListener(e, marcarUsuario, true); });
    window.removeEventListener('scroll', alScroll);
  }
  function alScroll() {
    if (usuarioActuo || Date.now() - inicio > VENTANA_MS) {
      quitar();
      return;
    }
    var y = window.scrollY || document.documentElement.scrollTop || 0;
    if (y > 40) {
      var el = document.scrollingElement || document.documentElement;
      el.scrollTop = 0;
    }
  }

  eventos.forEach(function (e) { window.addEventListener(e, marcarUsuario, { capture: true, passive: true }); });
  window.addEventListener('scroll', alScroll, { passive: true });
  setTimeout(quitar, VENTANA_MS + 200);
})();
